exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/collections.js-WebpackMultiOutput";